var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrewChangeTaskList',{attrs:{"title":"Accommodations","fullsize":false,"callId":0}}),_c('br'),_c('CrewChangePeopleList',{attrs:{"callId":0}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }